import { getApiBaseUrl } from '../utils/apiBaseUrl';

const apiBaseUrl = () => getApiBaseUrl() || 'https://localhost:8082';

const buildQuery = ({ email, team, token, messageId }) => {
  const params = new URLSearchParams();
  if (email) params.set('email', email);
  if (team) params.set('team', team);
  if (token) params.set('token', token);
  if (messageId) params.set('mid', messageId);
  return params.toString();
};

const requestJson = async (path, { method = 'GET' } = {}) => {
  const response = await fetch(`${apiBaseUrl()}${path}`, {
    method,
    headers: {
      Accept: 'application/json',
    },
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.ok === false) {
    const error = new Error(payload?.error || response.statusText || 'Unsubscribe request failed');
    error.status = response.status;
    error.payload = payload;
    throw error;
  }
  return payload;
};

export const validateEmailUnsubscribe = ({ email, team, token, messageId }) => {
  const query = buildQuery({ email, team, token, messageId });
  return requestJson(`/email/unsubscribe?${query}`);
};

export const confirmEmailUnsubscribe = ({ email, team, token, messageId }) => {
  const query = buildQuery({ email, team, token, messageId });
  return requestJson(`/email/unsubscribe/one-click?${query}`, { method: 'POST' });
};
